var path = 'src/app/patients/renal-imaging/renal-imaging.html';
var html = "<h1 class=page-header>Renal Imaging</h1> <div renal-imaging-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/renal-imaging/renal-imaging.html
 ** module id = 567
 ** module chunks = 0
 **/